"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _HublyticsApi = _interopRequireDefault(require("../api/HublyticsApi"));

var FIRE_ALARM_APP_NAME = 'firealarm';
var FIRE_ALARM_SCREEN_NAME = 'firealarm-screen';
var HUBSPOT_ACCOUNT_ID = 53;
var USAGE_TYPE = 'USAGE';

var Analytics =
/*#__PURE__*/
function () {
  function Analytics() {
    (0, _classCallCheck2.default)(this, Analytics);
  }

  (0, _createClass2.default)(Analytics, [{
    key: "trackUsage",
    value: function trackUsage(event, alarmId, alarmRevision) {
      var appName = hubspot.bender && hubspot.bender.currentProject;
      var currentUserEmail = this.getCurrentUserEmail();
      var currentPortalId = this.getCurrentPortalId();
      var now = new Date().getTime();
      var trackingEvent = this.getTrackingEvent(event, alarmId, alarmRevision, appName, currentUserEmail, currentPortalId, now);

      _HublyticsApi.default.postEvent(trackingEvent, now);
    }
  }, {
    key: "getTrackingEvent",
    value: function getTrackingEvent(eventName, alarmId, alarmRevision, appName, userEmail, portalId, timestamp) {
      var identifier = "alarm-" + alarmId + "-revision-" + alarmRevision;
      var event = {
        hublytics_account_id: HUBSPOT_ACCOUNT_ID,
        what_event: eventName,
        what_event_class: USAGE_TYPE,
        where_app: FIRE_ALARM_APP_NAME,
        where_screen: FIRE_ALARM_SCREEN_NAME,
        where_subscreen: appName,
        who_team_identifier: portalId,
        when_timestamp: timestamp,
        where_app_override: FIRE_ALARM_APP_NAME,
        what_value_str: identifier,
        what_extra_json: JSON.stringify({
          alarm_id: alarmId,
          alarm_revision: alarmRevision
        })
      };

      if (userEmail && portalId) {
        event.who_identifier_v2 = "EMAIL:::" + userEmail + ":::" + portalId;
      }

      return event;
    }
  }, {
    key: "getCurrentUser",
    value: function getCurrentUser() {
      return window.hubspot && window.hubspot.user;
    }
  }, {
    key: "getCurrentUserEmail",
    value: function getCurrentUserEmail() {
      var currentUser = this.getCurrentUser();
      return currentUser && currentUser.email;
    }
  }, {
    key: "getCurrentPortal",
    value: function getCurrentPortal() {
      return window.hubspot && window.hubspot.portal;
    }
  }, {
    key: "getCurrentPortalId",
    value: function getCurrentPortalId() {
      var currentPortal = this.getCurrentPortal();
      return currentPortal && currentPortal.id;
    }
  }]);
  return Analytics;
}();

var _default = new Analytics();

exports.default = _default;
module.exports = exports.default;